import { FC, useEffect } from 'react';
import { Checkbox } from '../../../../components/checkbox/checkbox';
import { pageKey } from '../../../../helpers/path';
import { useQueryParams } from '../../../../hooks/use-query-params';
import { useToggle } from '../../../../hooks/use-toggle';
import { TableFilter } from '../table-filter';

interface Props {
  name: string;
  label: string;
  removeParams?: string[];
}

export const TableFilterCheckbox: FC<Props> = ({ name, label, removeParams }) => {
  const checkName = `${name}-check`;
  const { getQueryParams, addQueryParams } = useQueryParams();
  const params = getQueryParams();
  const checkParam = params[checkName];

  const [checked, toggleChecked, setChecked] = useToggle(!!params[checkName]);

  useEffect(() => {
    setChecked(!!checkParam);
  }, [checkParam]);

  const handleOk = () => {
    const resultParams: Record<string, string | undefined> = { [pageKey]: '1' };
    const checkParams = checked ? JSON.stringify({ checked }) : undefined;
    resultParams[checkName] = checkParams;

    if (removeParams) {
      removeParams.forEach((item) => {
        resultParams[`${item}-check`] = undefined;
      });
    }

    addQueryParams(resultParams);
  };

  const handleReset = () => {
    addQueryParams({ [checkName]: undefined, [pageKey]: '1' });
    setChecked(false);
  };

  return (
    <TableFilter onReset={handleReset} onSubmit={handleOk} name={name}>
      <Checkbox name={checkName} checked={checked} onClick={toggleChecked} label={label} />
    </TableFilter>
  );
};
